import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DialogUnlockFolderResponseData } from './models/dialog-unlock-folder-response-data';

@Component({
    selector: 'app-unlock-folder-response',
    templateUrl: './unlock-folder-response.component.html',
    styleUrls: ['./unlock-folder-response.component.scss'],
    imports: [MatCardModule, MatButtonModule]
})
export class UnlockFolderResponseComponent {
    /**
     * Constructeur.
     * @param dialogRef
     */
    constructor(
        public dialogRef: MatDialogRef<UnlockFolderResponseComponent>,
        @Inject(MAT_DIALOG_DATA) public data: DialogUnlockFolderResponseData
    ) {}

    /**
     * Appelée lorsque l'utilisateur clique sur le bouton 'Fermer'.
     */
    public close(): void {
        this.dialogRef.close();
    }
}
